import module from 'usuario/module.js'
import template from './template.html'
import {orderBy} from 'lodash'

const diacriticosRegex = /[,.\u0300-\u036f]/g
const diacriticosEspacios = /\s+\s/g
const normalizar = (valor) => valor.normalize('NFD').replace(diacriticosRegex, '').replace(diacriticosEspacios, ' ').toUpperCase().trim()

export class UsuarioPermisoModulosComponent {
  promise = null
  idUsuario = null
  filtro = ''
  mostrarTodos = false
  seleccionados = []
  touch = false

  constructor (UsuarioPermisosModulos) {
    this.UsuarioPermisosModulos = UsuarioPermisosModulos
  }

  $onInit () {
    this.promise = this.UsuarioPermisosModulos.get(this.idUsuario)
      .then((response) => {
        let data = orderBy(response.data, ['descripcion'])
        data.forEach((item) => (item.busqueda = normalizar(item.descripcion).concat(' ', normalizar(item.modulo))))
        this.data = data
        this.filtrar()
      })
  }

  aceptar () {
    if (this.asignarPermisos) return

    this.asignarPermisos = true
    this.error = null
    this.guardando = true

    let data = this.data.filter((item) => item.activo).map((item) => {
      return {
        id_modulo: item.id_modulo,
        id_permiso: item.id_permiso,
      }
    }).sort()

    this.UsuarioPermisosModulos.put(this.idUsuario, data)
      .then(() => (this.touch = false))
      .catch((error) => (this.error = error.data || error))
      .finally(() => (this.guardando = false))
  }

  filtrar () {
    let filtro = normalizar(this.filtro)
    this.resultados = this.data.filter(item => item.busqueda.contains(filtro) && (this.filtro.length ? true : this.mostrarTodos ? item : item.activo))

    this.totalizar()
  }

  seleccionarMultiple (items, seleccionado) {
    !this.touch ? this.touch = true : angular.noop()

    items.forEach((item) => (item.activo = seleccionado))

    this.totalizar()
  }

  seleccionarToggle () {
    !this.touch ? this.touch = true : angular.noop()

    this.resultados.forEach((item) => (item.activo = !this.todosSeleccionados))

    this.filtrar()
  }

  totalizar () {
    this.todosSeleccionados = this.resultados.every((item) => item.activo)

    this.seleccionados = this.data.filter((item) => item.activo)

    if (!this.seleccionados.length && !this.mostrarTodos) {
      this.mostrarTodos = true
      this.filtrar()
    }
  }

  todosModulos () {
    this.mostrarTodos = !this.mostrarTodos

    this.filtrar()
  }

  limpiar () {
    this.filtro = ''
    this.filtrar()
  }
}

module.component('usuarioPermisosModulos', {
    controller: UsuarioPermisoModulosComponent,
    template,
    bindings: {
      idUsuario: '<',
    },
  },
)



// WEBPACK FOOTER //
// ./src/usuario/components/permisos/modulos/component.js